import { TabbedForm } from "react-admin";
import { AgendaFormBasic } from "./AgendaFormBasic";
import { AgendaFormQuestions } from "./AgendaFormQuestions";
import { NoDeleteToolbar } from "../../components/NoDeleteToolbar";
import { withUpload } from "../../lib/withUpload";
import { useWatch } from 'react-hook-form';

const ConditionalFormTab = (props) => {
    const isReturned = useWatch({ name: props.field });
    return isReturned ? <TabbedForm.Tab {...props} /> : null;
};

export function AgendaForm({ hideSendPushNotification = false, username = '' }) {
 
  return (
    <TabbedForm defaultValues={withUpload('mediaId', 'media')} toolbar={<NoDeleteToolbar />}>
      <TabbedForm.Tab label="resources.agenda.tabs.placement">
        <AgendaFormBasic hideSendPushNotification={hideSendPushNotification} username={username} />
      </TabbedForm.Tab>
      <ConditionalFormTab field="allowRegistrations" label="resources.agenda.tabs.questions" >
        <AgendaFormQuestions />
      </ConditionalFormTab>
    </TabbedForm>
  )
}